import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const useRoutePathname = () => {
    const { pathname } = useLocation();
    const params = useParams();

    return useMemo(() => ({
        route: Object.entries(params).reduce((path, [key, value]) => path.replace(`/${value}`, `/:${key}`), pathname),
        pathname,
        params,
    }), [pathname, params]);
};

export default useRoutePathname;
